import { HelpCircle, CheckCircle2, XCircle, Lightbulb } from "lucide-react";

export default function DecisionPanel({ questions, onAnswer, disabled }) {
  if (!questions || questions.length === 0) return null;
  const done = questions.filter((q) => q.completed).length;

  return (
    <div className="bg-card border border-border/60 rounded-md" data-testid="decision-panel">
      <div className="px-3 py-2 border-b border-border/60 bg-popover flex items-center justify-between">
        <span className="flex items-center gap-1.5 label-ot text-status-warning"><HelpCircle className="w-3.5 h-3.5" />Analyst Questions</span>
        <span className="font-mono text-xs text-muted-foreground">{done}/{questions.length}</span>
      </div>
      <div className="p-3 space-y-3">
        {questions.map((q) => {
          const answered = q.selected_index != null && q.selected_index !== undefined;
          return (
            <div key={q.id} data-testid={`question-${q.id}`} className="border border-border/50 rounded-sm p-3 bg-popover/50">
              <p className="text-xs font-medium mb-2.5">{q.question}</p>
              <div className="space-y-1.5">
                {q.options.map((opt, i) => {
                  const isSelected = q.selected_index === i;
                  let cls = "border-border bg-card hover:border-primary/50 hover:bg-secondary/40";
                  if (answered && isSelected) {
                    cls = q.correct ? "border-status-normal bg-status-normal/10" : "border-status-critical bg-status-critical/10";
                  } else if (answered) {
                    cls = "border-border/40 bg-card opacity-60";
                  }
                  return (
                    <button
                      key={i}
                      data-testid={`option-${q.id}-${i}`}
                      disabled={disabled || answered}
                      onClick={() => onAnswer(q.id, i)}
                      className={`w-full text-left flex items-center gap-2 px-2.5 py-1.5 rounded-sm border text-xs transition-colors ${cls}`}
                    >
                      <span className="font-mono text-[10px] text-muted-foreground w-4">{String.fromCharCode(65 + i)}</span>
                      <span className="flex-1">{opt}</span>
                      {answered && isSelected && (q.correct ? <CheckCircle2 className="w-4 h-4 text-status-normal" /> : <XCircle className="w-4 h-4 text-status-critical" />)}
                    </button>
                  );
                })}
              </div>
              {answered && (
                <div className={`mt-2 flex items-start gap-2 text-[11px] rounded-sm p-2 ${q.correct ? "bg-status-normal/10" : "bg-status-critical/10"}`}>
                  <Lightbulb className={`w-3.5 h-3.5 shrink-0 mt-0.5 ${q.correct ? "text-status-normal" : "text-status-critical"}`} />
                  <span><span className={`font-semibold ${q.correct ? "text-status-normal" : "text-status-critical"}`}>{q.correct ? "Correct. " : "Incorrect. "}</span><span className="text-foreground/80">{q.explanation}</span></span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
